"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var css_1 = require("@emotion/css");
var AudioVisualizer_styles_1 = require("../AudioVisualizer.styles");
var LoaderIcon = function (_a) {
    var color = _a.color;
    var style = { backgroundColor: color };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { style: style, className: (0, css_1.cx)(AudioVisualizer_styles_1.styles.loaderBar, AudioVisualizer_styles_1.styles.loaderBar1) }, void 0), (0, jsx_runtime_1.jsx)("div", { style: style, className: (0, css_1.cx)(AudioVisualizer_styles_1.styles.loaderBar, AudioVisualizer_styles_1.styles.loaderBar2) }, void 0), (0, jsx_runtime_1.jsx)("div", { style: style, className: (0, css_1.cx)(AudioVisualizer_styles_1.styles.loaderBar, AudioVisualizer_styles_1.styles.loaderBar3) }, void 0)] }, void 0));
};
exports.LoaderIcon = LoaderIcon;
